import React, { useEffect, ChangeEvent } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import { useSelector, useDispatch } from 'react-redux';
import DropdownList from '../../GeneralForm/DropdownList';
import DatePicker from '../../GeneralForm/ReactDatePicker';
import DropdownTreeSelect from '../../GeneralForm/DropdownTreeSelect';
import CompanySearchComponent from '../../GeneralForm/CompanySearchComponent';
import InvestorSearchComponent from '../../GeneralForm/InvestorSearchComponent';
import numConst from '../../../constants/NumberConstants';
import SearchInput from '../../GeneralForm/DropdownVirtualized';
import { AppDispatch, RootState } from '../../../store';
import ControlledCollapseComponent from '../../GeneralForm/ControlledCollapsedComponent';
import {
  handleNewsFreeSearchText,
  handleNewsProductOnChange,
  handleNewsEventOnChange,
  handleNewsPeriodSelection,
  handleTreeViewActivistObjective,
  handleNewsStakeholding,
  handleNewsfilterSelection,
  handleCompanyChangePeerGrp,
  handleInvestorChangePeerGrp,
  handleClearPeerGroupCompanySelection,
  handleClearPeerGroupInvestorSelection,
  handleOnStartDateChange,
  handleOnEndDateChange,
} from '../../../features/NewsContainer/NewsSlice';

import {
  HandleFilterModel,
  HandleInvestorFilterModel,
  handleCompanySearchOptionSelection,
  handleIndustrySelection,
  handleCompanySelection,
  handleShowIndividualOption,
  handleShowGroupOption,
  handleBulkCompanySelection,
  listInvestorTypeAndSubtype,
  getCompanySearchOptions,
  getInvestorSearchOptions,
  handleExchangeSelectionChange,
  handleAIPeerGroupSelection,
  handleMarketCapSelection,
  handleMarketCapMinRange,
  handleMarketCapMaxRange,
  HandleTreeViewIndustry,
  handleSaveCurrentList,
  HandleTreeViewCompanyLocation,
  getAllCompanySearchSelection,
  ResetCompanySearchOptionSelection,
  handleCompanySearchUpdateReq,
  handleCompanySingleSelection,
  handleCompanySearchDeleteReq,
  HandleTreeViewInvestorLocation,
  handleInvestorSelection,
  handleInvestorIsBulkUpload,
  handleBulkInvestorSelection,
  handleByShareholderOfCompany,
  getAllInvestorsFromShareholderOfCompany,
  HandleTreeViewListInvestorTypeAndSubtype,
  handleSaveInvestorCurrentList,
  handleInvestorSearchDeleteReq,
  handleInvestorSearchUpdateReq,
  handleInvestorSearchOptionSelection,
  ResetInvestorSearchOptionSelection,
  handleAumCategorySelection,
  handleInvMarketCapMinRange,
  handleInvMarketCapMaxRange,
  handleResetCompnaySelections,
  handleResetInvestorSelections,
  handleIndexSelectionChange,
  handleRunReq,
  searchInvestorsReq,
  getInvestorSearchSelectionReq,
  searchCompanyAndIndustriesReq,
  piListOfIndicesReq,
  getListOfExchange,
  getAIPeersGroups,
  handleInvestorSavedPeerGroupsInputChange,
  getAumCategorylistReq,
  getPIListSectorsAndIndustriesReq,
  getTreeRegionsAndCountries,
  getCurrentShareholderReq,
  allIssuersReq,
  handleSavedPeerGroupsInputChange,
} from '../../../features/DashboardContainer/DashboardSlice';

interface NewsFilterProps {
  handleSearchBtn: () => void;
  isOpenTab: boolean;
  onIsOpenTab: (isOpen: boolean) => void;
}

const NewsFilter: React.FC<NewsFilterProps> = ({ handleSearchBtn, isOpenTab, onIsOpenTab }) => {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true }) as { q?: string };
  const history = useHistory();
  const dispatch = useDispatch<AppDispatch>();
  const newsState = useSelector((state: RootState) => state.news);
  const dashBoardState = useSelector((state: RootState) => state.dashboard);

  useEffect(() => {
    async function getData(): Promise<void> {
      if (query.q) {
        history.push(location.pathname);
      }
    }
    getData();
  }, [history, location.pathname, query.q, isOpenTab]);

  useEffect(() => {
    if (dashBoardState.companySelection?.length > 0) {
      dispatch(searchCompanyAndIndustriesReq({ rowdata: dashBoardState.companySelection }));
    }

    dispatch(handleRunReq());

    if (dashBoardState.investorSelection?.length > 0) {
      dispatch(searchInvestorsReq({ rowdata: dashBoardState.investorSelection }));
    }

    dispatch(getInvestorSearchSelectionReq(dashBoardState.investorSearchOptionsSelection?.value));
    dispatch(piListOfIndicesReq());
    dispatch(getListOfExchange());
    dispatch(getAIPeersGroups());
    dispatch(getInvestorSearchOptions());
    dispatch(getAllInvestorsFromShareholderOfCompany());
    dispatch(listInvestorTypeAndSubtype());
    dispatch(getAumCategorylistReq());
    dispatch(getPIListSectorsAndIndustriesReq());
    dispatch(getTreeRegionsAndCountries());
    dispatch(getCurrentShareholderReq());
    dispatch(allIssuersReq());
    dispatch(getAllCompanySearchSelection());
    dispatch(getCompanySearchOptions());
    dispatch(handleInvestorSavedPeerGroupsInputChange());
    dispatch(handleInvestorSearchOptionSelection());
    dispatch(ResetInvestorSearchOptionSelection());
  }, []);

  const handleFreeSearchUpdate = (event: ChangeEvent<HTMLInputElement>): void => {
    dispatch(handleNewsFreeSearchText(event));
    dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
  };

  const handleModuleChange = (selectedValue: { value: string | number; label: string }[]): void => {
    dispatch(handleNewsProductOnChange(selectedValue));
    dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
  };

  const handleEventChange = (selectedValue: { value: string | number; label: string }[]): void => {
    dispatch(handleNewsEventOnChange(selectedValue));
    dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
  };

  const handlePeriodChange = (selectedPeriod: { value: string | number; label: string }): void => {
    dispatch(handleNewsPeriodSelection(selectedPeriod));
    dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
  };

  const handleActivistObjectiveChange = (
    currentNode: { value: string | number; label: string; _depth: number; _parent?: string },
    selectedNodes: { value: string | number; label: string; _depth: number; _parent?: string }[],
  ): void => {
    dispatch(handleTreeViewActivistObjective(currentNode, selectedNodes));
    dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
  };

  const handleStakeholdingChange = (selectedValue: { value: string | number; label: string }[]): void => {
    dispatch(handleNewsStakeholding(selectedValue));
    dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
  };

  const handleByCompanySelection = (): void => {
    dispatch(HandleFilterModel(true));
    dispatch(handleCompanyChangePeerGrp());
  };

  const handleByInvestorSelection = (): void => {
    dispatch(HandleInvestorFilterModel(true));
    dispatch(handleInvestorChangePeerGrp());
  };

  return (
    <div>
      <ControlledCollapseComponent onIsOpenTab={onIsOpenTab} isOpen={isOpenTab} Heading="News Filter">
        <CompanySearchComponent
          showFilterModel={dashBoardState.showFilterModel}
          listOfcompanySearchOptions={dashBoardState.companySearchOptions}
          HandleFilterModel={() => dispatch(HandleFilterModel())}
          handleCompanySelection={(selection: { value: string | number; label: string }[]) =>
            dispatch(handleCompanySelection(selection))
          }
          handleShowIndividualOption={() => dispatch(handleShowIndividualOption())}
          showIndividualOption={dashBoardState.showIndividualOption}
          handleShowGroupOption={() => dispatch(handleShowGroupOption())}
          handleBulkCompanySelection={(companyData: { pid: string | number; company_name: string }) =>
            dispatch(handleBulkCompanySelection(companyData))
          }
          piListIndices={dashBoardState.piListIndices}
          handleIndexSelectionChange={(selectedIndex: { value: string | number; label: string }[]) =>
            dispatch(handleIndexSelectionChange(selectedIndex))
          }
          indexSelection={dashBoardState.indexSelection}
          listOfExchange={dashBoardState.listExchange}
          handleExchangeSelectionChange={(selectedExchange: { value: string | number; label: string }[]) =>
            dispatch(handleExchangeSelectionChange(selectedExchange))
          }
          exchangeSelection={dashBoardState.exchangeSelection}
          aiPeerGroups={dashBoardState.listAIPeersGroups}
          handleAIPeerGroupSelection={(selectedGroup: { value: string | number; label: string }[]) =>
            dispatch(handleAIPeerGroupSelection(selectedGroup))
          }
          aiPeerGroupSelection={dashBoardState.aiPeerGroupSelection}
          listMarketCap={dashBoardState.listMarketCap}
          marketCapSelection={dashBoardState.marketCapSelection}
          handleMarketCapSelection={(selectedCap: { value: number; label: string }) =>
            dispatch(handleMarketCapSelection(selectedCap))
          }
          txtMarketCapMinRange={dashBoardState.txtMarketCapMinRange}
          txtMarketCapMaxRange={dashBoardState.txtMarketCapMaxRange}
          handleMarketCapMinRange={(event: ChangeEvent<HTMLInputElement>) => dispatch(handleMarketCapMinRange(event))}
          handleMarketCapMaxRange={(event: ChangeEvent<HTMLInputElement>) => dispatch(handleMarketCapMaxRange(event))}
          handleIndustrySelection={(selectedIndustry: { value: string | number; _depth: number; _parent?: string }[]) =>
            dispatch(handleIndustrySelection(selectedIndustry))
          }
          industrySelection={dashBoardState.industrySelection}
          companyLocationSelection={dashBoardState.companyLocationSelection}
          piListOfSectorsAndIndustries={dashBoardState.piListSectorsAndIndustries}
          HandleTreeViewIndustry={(currentNode, selectedNodes) =>
            dispatch(HandleTreeViewIndustry(currentNode, selectedNodes))
          }
          listRegeionAndCountries={dashBoardState.listRegeionAndCountries}
          defaultCmpRegeionAndCountries={dashBoardState.defaultCmpRegeionAndCountries}
          lstInvestorRegeionAndCountries={dashBoardState.lstInvestorRegeionAndCountries}
          handleSaveCurrentList={(inputValue: string) => dispatch(handleSaveCurrentList(inputValue))}
          HandleTreeViewCompanyLocation={(currentNode, selectedNodes) =>
            dispatch(HandleTreeViewCompanyLocation(currentNode, selectedNodes))
          }
          companySearchOptionSelection={dashBoardState.companySearchOptionSelection}
          handleCompanySearchOptionSelection={(selectedOption: {
            value: string | number;
            label: string;
            isSaved?: boolean;
          }) => dispatch(handleCompanySearchOptionSelection(selectedOption))}
          getAllCompanySearchSelection={(e) => dispatch(getAllCompanySearchSelection(e))}
          txtSaveCurrentList={dashBoardState.txtSaveCurrentList}
          ResetCompanySearchOptionSelection={() => dispatch(ResetCompanySearchOptionSelection())}
          saveCurrentListButtonText={dashBoardState.saveCurrentListButtonText}
          handleCompanyAndIndustry={(data) => dispatch(searchCompanyAndIndustriesReq(data))}
          freeSearchRecordset={dashBoardState.freeSearchRecordset}
          companySelection={dashBoardState.companySelection}
          companySingleSelection={dashBoardState.companySingleSelection}
          handleSavedPeerGroupsInputChange={dispatch(handleSavedPeerGroupsInputChange())}
          handleCompanySearchUpdateReq={(data) => dispatch(handleCompanySearchUpdateReq(data))}
          getCompanySearchOptions={() => dispatch(getCompanySearchOptions())}
          handleCompanySearchDeleteReq={(data) => dispatch(handleCompanySearchDeleteReq(data))}
          handleCompanySingleSelection={(selectedItem: { value: string | number; label: string }) =>
            dispatch(handleCompanySingleSelection(selectedItem))
          }
          defaultPiListSectorsAndIndustries={dashBoardState.defaultPiListSectorsAndIndustries}
        />

        <InvestorSearchComponent
          HandleInvestorFilterModel={() => dispatch(HandleInvestorFilterModel())}
          investorSearchOptions={dashBoardState.investorSearchOptions}
          investorSearchOptionsSelection={dashBoardState.investorSearchOptionsSelection}
          showInvestorFilterModel={dashBoardState.showInvestorFilterModel}
          HandleTreeViewInvestorLocation={(currentNode, selectedNodes) =>
            dispatch(HandleTreeViewInvestorLocation(currentNode, selectedNodes))
          }
          investorLocationSelection={dashBoardState.investorLocationSelection}
          listInvestorTypeAndSubtype={dashBoardState.listInvestorTypeAndSubtype}
          listInvestorTypeAndSubtypeSelection={dashBoardState.listInvestorTypeAndSubtypeSelection}
          handleInvestorSelection={(selectedInvestor: { value: string | number; label: string }[]) =>
            dispatch(handleInvestorSelection(selectedInvestor))
          }
          investorSelection={dashBoardState.investorSelection}
          handleInvestorIsBulkUpload={(flag: boolean) => dispatch(handleInvestorIsBulkUpload(flag))}
          isInvestorBulkUpload={dashBoardState.isInvestorBulkUpload}
          freeSearchRecordset={dashBoardState.freeSearchRecordset}
          handleSearchInvestor={(data) => dispatch(searchInvestorsReq(data))}
          lstInvestorRegeionAndCountries={dashBoardState.lstInvestorRegeionAndCountries}
          handleBulkInvestorSelection={(data: { investor_id: string | number; investor_name: string }) =>
            dispatch(handleBulkInvestorSelection(data))
          }
          listRegeionAndCountries={dashBoardState.listRegeionAndCountries}
          listByIndivProponent={dashBoardState.listByIndivProponent}
          selectionByIndivProponent={dashBoardState.selectionByIndivProponent}
          handleByShareholderOfCompany={(selectedValue: { value: string | number; label: string }) =>
            dispatch(handleByShareholderOfCompany(selectedValue))
          }
          getAllInvestorsFromShareholderOfCompany={(e) => dispatch(getAllInvestorsFromShareholderOfCompany(e))}
          HandleTreeViewListInvestorTypeAndSubtype={(currentNode, selectedNodes) =>
            dispatch(HandleTreeViewListInvestorTypeAndSubtype(currentNode, selectedNodes))
          }
          listMarketCap={dashBoardState.listMarketCap}
          handleMarketCapSelection={(selectedCap: string) => dispatch(handleMarketCapSelection(selectedCap))}
          marketCapSelection={dashBoardState.marketCapSelection}
          listAumCategory={dashBoardState.listAumCategory}
          aumCategorySelection={dashBoardState.aumCategorySelection}
          handleAumCategorySelection={(selectedAum: { value: number; label: string }) =>
            dispatch(handleAumCategorySelection(selectedAum))
          }
          invTxtMarketCapMinRange={dashBoardState.invTxtMarketCapMinRange}
          invTxtMarketCapMaxRange={dashBoardState.invTxtMarketCapMaxRange}
          handleInvMarketCapMinRange={(event: ChangeEvent<HTMLInputElement>) =>
            dispatch(handleInvMarketCapMinRange(event))
          }
          handleInvMarketCapMaxRange={(event: ChangeEvent<HTMLInputElement>) =>
            dispatch(handleInvMarketCapMaxRange(event))
          }
          handleMarketCapMinRange={(event: ChangeEvent<HTMLInputElement>) => dispatch(handleMarketCapMinRange(event))}
          txtMarketCapMinRange={dashBoardState.txtMarketCapMinRange}
          txtMarketCapMaxRange={dashBoardState.txtMarketCapMaxRange}
          handleMarketCapMaxRange={(event: ChangeEvent<HTMLInputElement>) => dispatch(handleMarketCapMaxRange(event))}
          handleSaveInvestorCurrentList={(input: string) => dispatch(handleSaveInvestorCurrentList(input))}
          txtSaveCurrentList={dashBoardState.txtSaveCurrentList}
          handleInvestorSearchDeleteReq={(data) => dispatch(handleInvestorSearchDeleteReq(data))}
          getInvestorSearchOptions={() => dispatch(getInvestorSearchOptions())}
          isSaveCurrentListButtonDeleteDisable={dashBoardState.isSaveCurrentListButtonDeleteDisable}
          saveCurrentListButtonText={dashBoardState.saveCurrentListButtonText}
          handleInvestorSearchUpdateReq={(data) => dispatch(handleInvestorSearchUpdateReq(data))}
          handleInvestorSearchOptionSelection={(selectedOption: any) =>
            dispatch(handleInvestorSearchOptionSelection(selectedOption))
          }
          GetInvestorSearchSelection={() => dispatch(getInvestorSearchSelectionReq())}
          ResetInvestorSearchOptionSelection={() => dispatch(ResetInvestorSearchOptionSelection())}
          listDefaultInvestorTypeAndSubtype={dashBoardState.listDefaultInvestorTypeAndSubtype}
          invListRegeionAndCountries={dashBoardState.invListRegeionAndCountries}
        />

        <div className="row pt-2">
          <div className="container">
            <div className="row">
              <div className="col-sm">
                <div className="row">
                  <label htmlFor="byCompanySelection" className="col-sm-4 col-form-label">
                    <button type="button" className="btn btn-primary btn-sm" onClick={handleByCompanySelection}>
                      By Company Selection
                    </button>
                  </label>
                  <div className="col-sm-8 text-secondary labelNewsCompanyFilter">
                    {newsState.companyPeerGroupSelection !== undefined ? (
                      <div className="btnPeerGrpRemove">
                        {newsState.companyPeerGroupSelection.label}
                        <i
                          className="bi bi-backspace-fill"
                          title="Clear selection"
                          onClick={() => {
                            dispatch(handleClearPeerGroupCompanySelection());
                            dispatch(handleResetCompnaySelections());
                          }}
                        />
                      </div>
                    ) : (
                      'No specific company selected'
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm">
                <div className="row">
                  <label htmlFor="inputPassword" className="col-sm-4 col-form-label">
                    <button type="button" className="btn btn-primary btn-sm" onClick={handleByInvestorSelection}>
                      By Investor Selection
                    </button>
                  </label>
                  <div className="col-sm-8 text-secondary labelNewsCompanyFilter">
                    {newsState.investorPeerGroupSelection !== undefined ? (
                      <div className="btnPeerGrpRemove">
                        {newsState.investorPeerGroupSelection.label}
                        <i
                          className="bi bi-backspace-fill"
                          title="Clear selection"
                          onClick={() => {
                            dispatch(handleClearPeerGroupInvestorSelection());
                            dispatch(ResetInvestorSearchOptionSelection());
                            dispatch(handleResetInvestorSelections());
                          }}
                        />
                      </div>
                    ) : (
                      'No specific investor selected'
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm col-md-6">
                <div className="row align-items-center">
                  <label htmlFor="freetextsearch" className="col-sm-4 col-form-label ">
                    Free Text search
                  </label>
                  <div className="col-sm-8 text-secondary labelNewsCompanyFilter">
                    <input
                      type="text"
                      className="form-control"
                      aria-describedby="freetextsearch"
                      placeholder="(Optional) Enter text to search..."
                      value={newsState.newsFreeSearchText}
                      onChange={handleFreeSearchUpdate}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm col-md-6">
                <div className="row align-items-center">
                  <label htmlFor="freetextsearch" className="col-sm-4 col-form-label ">
                    Modules
                  </label>
                  <div className="col-sm-8 labelNewsCompanyFilter">
                    <SearchInput
                      onChange={(event) => handleModuleChange(event)}
                      selectValue={newsState.productSelections}
                      options={newsState.lstProductMembership}
                      isMulti
                      placeholder="(Optional) Choose one or more modules…"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <label htmlFor="ddlEvents" className="col-form-label">
              <b>Specific Searches:</b>
            </label>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-sm">
                <div className="row">
                  <label htmlFor="inputPassword" className="col-sm-4 col-form-label">
                    Event
                  </label>
                  <div className="col-sm-8">
                    <DropdownList
                      handleChange={(event) => handleEventChange(event)}
                      isMulti
                      options={newsState.newsEvents}
                      Dvalue={newsState.newsEventSelection}
                      placeholder="(Optional) Choose one or more events…"
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm">
                <div className="mb-3 row">
                  <label htmlFor="inputPassword" className="col-sm-4 col-form-label">
                    Period
                  </label>
                  <div className="col-sm-8">
                    <DropdownList
                      handleChange={(event) => handlePeriodChange(event)}
                      isMulti={false}
                      options={newsState.newsPeriod}
                      Dvalue={newsState.newsPeriodSelection}
                      placeholder="(Optional) Choose period..."
                    />
                    {newsState.newsPeriodSelection && newsState.newsPeriodSelection.value === '' && (
                      <div>
                        <label htmlFor="ddlEvents" className="col-form-label">
                          Specify Period From:
                        </label>
                        <br />
                        <div className="row">
                          <div className="col-6">
                            <DatePicker
                              selectedDate={newsState.startNewsPeriodDate}
                              handleDateChange={(event) => {
                                dispatch(handleOnStartDateChange(event || null));
                                dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
                              }}
                              dateFormat="dd-MMM-yyyy"
                              minDate={new Date('2010-1-1')}
                              maxDate={newsState.endNewsPeriodDate || new Date()}
                              //
                              showYearDropdown
                              showMonthDropdown
                              useShortMonthInDropdown
                            />
                          </div>
                          <div className="col-6">
                            <DatePicker
                              selectedDate={newsState.endNewsPeriodDate}
                              handleDateChange={(event) => {
                                dispatch(handleOnEndDateChange(event || null));
                                dispatch(handleNewsfilterSelection(newsState.CompanySearchId));
                              }}
                              dateFormat="dd-MMM-yyyy"
                              minDate={newsState.startNewsPeriodDate || new Date('2010-1-1')}
                              maxDate={new Date()}
                              //
                              showYearDropdown
                              showMonthDropdown
                              useShortMonthInDropdown
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-sm">
                <div className="row">
                  <label htmlFor="inputPassword" className="col-sm-4 col-form-label">
                    Activist Objective
                  </label>
                  <div className="col-sm-8">
                    <DropdownTreeSelect
                      onChangeSelection={(currentnode, selectednode) => {
                        handleActivistObjectiveChange(currentnode, selectednode);
                      }}
                      options={newsState.allActivistObjective}
                      placeholder={
                        (newsState.activistObjectiveSelection?.length || 0) === numConst.EMPTY_TABLE_LENGTH
                          ? '(Optional) Choose one or more objectives…'
                          : ' '
                      }
                      totalSelection={newsState.activistObjectiveSelection?.length || 0}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm">
                <div className="row">
                  <label htmlFor="inputPassword" className="col-sm-4 col-form-label">
                    Activist Stakeholding
                  </label>
                  <div className="col-sm-8">
                    <DropdownList
                      handleChange={(event) => handleStakeholdingChange(event)}
                      isMulti
                      options={newsState.newsStakeholding}
                      Dvalue={newsState.newsStakeholdingSelection}
                      placeholder="(Optional) Choose one or more stakeholding…"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2 row">
              <div className="col-12">
                <button
                  type="button"
                  className="btn btn-primary btn-sm float-end"
                  onClick={() => {
                    handleSearchBtn();
                  }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </ControlledCollapseComponent>
    </div>
  );
};

export default React.memo(NewsFilter);
